import { render, staticRenderFns } from "./positionDialog.vue?vue&type=template&id=3372c9a3&scoped=true&"
import script from "./positionDialog.vue?vue&type=script&lang=js&"
export * from "./positionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3372c9a3",
  null
  
)

export default component.exports